import { pageSizeForDataSet } from 'utilities';

const getOptions = isFrequencyTable => ({
  search: !isFrequencyTable,
  paging: !isFrequencyTable,
  sorting: !isFrequencyTable,
  draggable: !isFrequencyTable,
  searchFieldAlignment: 'left',
  actionsColumnIndex: -1,
  pageSizeOptions: pageSizeForDataSet,
  emptyRowsWhenPaging: false,
  showTitle: false,
  toolbar: !isFrequencyTable,
  addRowPosition: 'first',
  headerStyle: {
    background: '#f7f7f7',
    borderBottom: '2px solid #dfdfdf',
    width: 'inherit',
    fontWeight: 600,
    position: !isFrequencyTable ? 'sticky' : 'relative',
    top: 0
  },
  maxBodyHeight: '90vh',
  actionsCellStyle: {
    background: '#f7f7f7',
    borderLeft: '2px solid #dfdfdf',
    padding: '0 10px',
    minWidth: 90
  },
  style: {
    maxWidth: '100%',
    overflowX: 'scroll',
    marginLeft: '5em',
    overflowY: 'visible',
    paddingBottom: '1px'
  },
  padding: 'dense'
});

// remove default tooltip for add row button
const localizationStrings = {
  body: {
    addTooltip: ''
  }
};

export {
  getOptions,
  localizationStrings
};
